import React from 'react'
import { Link } from 'react-router-dom'

const Home = () => {
  return (
      <ul className="homelist">
        <li className={'films'}><Link to="/feature-films"><span>feature films</span></Link></li>
        <li className={'commercials'}><Link to="/commercials"><span>commercials</span></Link></li>
        <li className={'series'}><Link to="/tv-series"><span>tv series</span></Link></li>
      </ul>
  )
}

export default Home